import { errorCodesApply, errorMessages, errorCodeToMessageIdSetMap } from "./event-planting-form";
import * as plantingModuleCont from "./event-planting-container";

export const plantingModule = {
    ...plantingModuleCont,
    errorCodesApply,
    errorMessages,
    errorCodeToMessageIdSetMap,
};
